const BASE_URL = process.env.REACT_APP_BASE_URL;

// AUTH ENDPOINTS
export const endpoints = {
  SENDOTP_API: BASE_URL + "/auth/sendotp",
  REGISTER_API: BASE_URL + "/auth/register",
  SIGNUP_API: BASE_URL + "/auth/signup",

  SIGNIN_API: BASE_URL + "/auth/signin",
  CHANGE_PASSWORD_API: BASE_URL + "/auth/change-password",

  RESETPASSTOKEN_API: BASE_URL + "/auth/reset-password-token",
  RESETPASSWORD_API: BASE_URL + "/auth/reset-password",

  SEND_EMAIL_OTP_API: BASE_URL + "/auth/sendotp-email",
  VERIFY_EMAIL_OTP_API: BASE_URL + "/auth/verifyotp-email",

  UPDATE_IMAGE_API: BASE_URL + "/auth/update-image",
  UPDATE_INFO_API: BASE_URL + "/auth/update-info",

  GET_USER_DETAILS_API: BASE_URL + "/auth/get-user-details",
  GET_ALL_USERS_API: BASE_URL + "/auth/get-all-user-details",
  EDIT_USER_API: (userId) => `${BASE_URL}/auth/edit-user/${userId}`,
  DELETE_USER_API: (userId) => `${BASE_URL}/auth/delete-user/${userId}`,
};

//Conversation
export const conversationendpoints = {
  CREATE_CONVERSATION_API: BASE_URL + "/conversation",

  EDIT_CONVERSATION_TITLE_API: BASE_URL + "/conversation", // append /:id,

  GET_USER_CONVERSATIONS_API: BASE_URL + "/conversation",

  GET_CONVERSATION_BY_ID_API: BASE_URL + "/conversation", // append /:id

  DELETE_CONVERSATION_API: BASE_URL + "/conversation", // append /:id
};

//Message
export const messageendpoints = {
  GET_MESSAGES_BY_CONVERSATION_ID_API: BASE_URL + "/message", // Backend route: GET /api/message/:conversationId
  ADD_MESSAGE_API: BASE_URL + "/message", // Backend route: POST /api/message/:conversationId
};



